import t from "@/lang/lang";
import { Badge } from "@/shared/components/ui/badge";
import { ContractState } from "../types/contract";

/** ContractStateBadge shows the commercial state of a contract. */
export function ContractStateBadge({ state }: { state: ContractState }) {
  if (state === ContractState.Signed) {
    return <Badge>{t("Unterschrieben")}</Badge>;
  }
  return <Badge variant="outline">{t("Entwurf")}</Badge>;
}
